module.exports = __webpack_public_path__ + "img/unstabilized.9fb4b79c.png";